<script lang="ts">
import { defineComponent, inject, ref } from "vue";
import Infotext from "@/components/Infotext.vue";
import ValidierungsFehler from "@/components/ValidierungsFehler.vue";
import formValidierung from "@/businesslogic/formValidierung";
import Zeile from "@/components/grid/Zeile.vue";
import TitelZelle from "@/components/grid/TitelZelle.vue";
import Zelle from "@/components/grid/Zelle.vue";
import { Dropdowndaten } from "@/model/Dropdowndaten";
import Dropdown from "@/components/Vorschlagsliste/Dropdown.vue";
import Gewerbearten from "./Gewerbearten";
import dataUtils from "@/businesslogic/utils/dataUtils";
import { useFormStore } from "@/businesslogic/stores/formStore";

export default defineComponent({
  name: "Gewerbeinformationen",
  components: {
    ValidierungsFehler,
    Infotext,
    Zeile,
    TitelZelle,
    Zelle,
    Dropdown,
  },
  props: {
    gewerbeId: Number,
    fehler: Object,
  },
  setup(props) {
    const piniaStore = useFormStore();
    const istSichtbar: any = inject("istSichtbar");
    const wechsleSichtbarkeit: any = inject("wechsleSichtbarkeit");
    const { erzwingeGanzzahl } = formValidierung();
    const gewerbeflaecheMitId = ref("gewerbeflaeche" + props.gewerbeId);
    const GEWERBEART_SONSTIGE = "99000";
    const GEWERBEARTEN = ref(Gewerbearten);
    const gewerbeVorschlaege = GEWERBEARTEN.value.map((gewerbe) => gewerbe.beschreibung);
    const { gt } = dataUtils();

    function setzteBeschreibungImStore(gewerbeListeElement: any) {
      let gefunden = false;
      for (const gewerbeart of GEWERBEARTEN.value) {
        if (gewerbeart.beschreibung.toLowerCase() === gewerbeListeElement.beschreibung.toLowerCase()) {
          gewerbeListeElement.art = gewerbeart.art;
          gefunden = true;
        }
      }
      if (!gefunden) {
        gewerbeListeElement.art = gewerbeListeElement.beschreibung != "" ? GEWERBEART_SONSTIGE : "";
      }
    }

    const updateGewerbe = (value: any) => {
      piniaStore.state.gebaeudedaten.gewerbeListe[0].beschreibung = value;
      setzteBeschreibungImStore(piniaStore.state.gebaeudedaten.gewerbeListe[0]);
    };

    const dropdowndatenGewerbe = new Dropdowndaten(
      gewerbeVorschlaege,
      3,
      70,
      props.fehler,
      true,
      "Art des Gewerbes",
      "Bitte geben Sie die Art des Gewerbes an (3-70 Zeichen).",
    );

    return {
      piniaStore,
      istSichtbar,
      wechsleSichtbarkeit,
      gewerbeflaecheMitId,
      erzwingeGanzzahl,
      gewerbeVorschlaege,
      dropdowndatenGewerbe,
      updateGewerbe,
      gt,
    };
  },
});
</script>

<template>
  <zeile>
    <titel-zelle>
      <strong>{{ gt(piniaStore.state.gebaeudedaten.gewerbeAnzahl, 1) ? gewerbeId + "." : "" }} Gewerbe-Art</strong>
    </titel-zelle>
    <zelle>
      <dropdown
        name="gewerbe"
        :dropdowndaten="dropdowndatenGewerbe"
        :wertAktuell="piniaStore.state.gebaeudedaten.gewerbeListe[gewerbeId - 1].beschreibung"
        @updateVorschlag="updateGewerbe"
      />
      <validierungs-fehler :fehler-text="fehler?.gewerbe" />
    </zelle>
  </zeile>

  <zeile>
    <titel-zelle :zeige-info="true" :info-box-id="gewerbeflaecheMitId">
      <strong
        >{{ gt(piniaStore.state.gebaeudedaten.gewerbeAnzahl, 1) ? gewerbeId + "." : "" }} Anteil Gewerbefläche</strong
      >
      in %
    </titel-zelle>
    <zelle>
      <input
        type="number"
        @keydown="erzwingeGanzzahl"
        :name="gewerbeflaecheMitId"
        v-model.lazy.trim.number="piniaStore.state.gebaeudedaten.gewerbeListe[gewerbeId - 1].flaeche"
        class="c-form-control__input"
        min="1"
        max="49"
        data-fehlermeldung="Überwiegend gewerblich genutzte Gebäude können wir nicht versichern."
        data-cy="gewerbeGewerbeFlaeche"
        required
        aria-required="true"
        aria-label="Anteil Gewerbefläche in Prozent"
        :aria-describedby="gewerbeflaecheMitId"
      />
      <validierungs-fehler :fehler-text="fehler[gewerbeflaecheMitId]" />
      <infotext
        role="tooltip"
        :id="gewerbeflaecheMitId"
        :name="gewerbeflaecheMitId"
        text="Anteil der gewerblich genutzten Fläche in Prozent von der Gesamtfläche des Gebäudes."
      >
      </infotext>
    </zelle>
  </zeile>
</template>
